export default [
  {
    Page: "https://cleanbee.ie/",
    Keyword: "home cleaning service",
    avg_num_searches: "880",
    header: "Home Cleaning Service | CleanBee.ie",
    "Length (max 70 characters)": "35",
    description:
      "Home Cleaning Service ✴️ From oven to your entire house – high quality deep cleaning procedures all across the Ireland ❗ ❱❱❱ Try now!",
    "Length (max 155 characters)": "133",
    Communication: "Sukelta."
  },
  {
    Page: "house-cleaning",
    Keyword: "house cleaning",
    avg_num_searches: "590",
    header: "House Cleaning | CleanBee.ie",
    "Length (max 70 characters)": "28",
    description:
      "Best House cleaning services ✴️ Max, medium house cleaning bundles, apartment cleaning bundle ❗ ❱❱❱ Professional cleaning services in Ireland!",
    "Length (max 155 characters)": "142",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "oven-kitchen-cleaning",
    Keyword: "oven cleaning",
    avg_num_searches: "590",
    header: "Oven Cleaning - Oven Cleaners | CleanBee.ie",
    "Length (max 70 characters)": "43",
    description:
      "Oven cleaning services. oven cleaners in Ireland [good prices] ✴️ Professional cleaning services ❗ ❱❱❱ Book the cleaning of your oven!",
    "Length (max 155 characters)": "134",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "bathroom-cleaning",
    Keyword: "bathroom cleaning",
    avg_num_searches: "50",
    header: "Bathroom Cleaning Services | CleanBee.ie",
    "Length (max 70 characters)": "40",
    description:
      "Bathroom Cleaning Services - Professional services in Ireland ✴️ Shower cabin, batch, wc/toilet cleaning ❗ ❱❱❱ Visit and book our services!",
    "Length (max 155 characters)": "139",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "Kitchen",
    Keyword: "kitchen cleaning",
    avg_num_searches: "90",
    header: "Kitchen Cleaning | CleanBee.ie",
    "Length (max 70 characters)": "30",
    description:
      "Kitchen Cleaning - book here the cleaning of your kitchen ✴️ Gas hobs, electric hobs, fridge cleaning ❗ ❱❱❱  Book best cleaning services in Ireland!",
    "Length (max 155 characters)": "148",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "upholstery-cleaning",
    Keyword: "Upholstery cleaning\n\n",
    avg_num_searches: "1600",
    header: "Upholstery Cleaning | CleanBee.ie\n",
    "Length (max 70 characters)": "34",
    description:
      "Upholstery Cleaning Services in Ireland ✴️ Mattress, sitting room, sofa, armchair, chair cleaning ❗ ❱❱❱ Book the professioanl cleaning!",
    "Length (max 155 characters)": "135",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "carpet-floor-cleaning",
    Keyword: "Carpet cleaning, floor cleaning",
    avg_num_searches: "1000, 140",
    header: "Carpet Cleaning, Floor Cleaning | CleanBee.ie",
    "Length (max 70 characters)": "45",
    description:
      "Carpet Cleaning, Floor Cleaning - professional cleaning services ✴️ High quality cleaning procedures all across the Ireland ❗ ❱❱❱ Learn more!",
    "Length (max 155 characters)": "141",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "window-cleaning",
    Keyword: "window cleaning",
    avg_num_searches: "2400",
    header: "Window Cleaning | CleanBee.ie",
    "Length (max 70 characters)": "29",
    description:
      "Window Cleaning Services all across the Ireland ✴️ Window interior cleaning, window exterior cleaning ❗ ❱❱❱ Visit and book our services!",
    "Length (max 155 characters)": "136",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "powerwashing-services",
    Keyword: "Power Washing, soft washing",
    avg_num_searches: "4400, 140",
    header: "Power Washing, Soft Washing | CleanBee.ie",
    "Length (max 70 characters)": "41",
    description:
      "Power Washing, Soft Washing in Ireland [good prices] ✴️ Soft wash, powerwashing package ❗ ❱❱❱ Visit our page and learn more!",
    "Length (max 155 characters)": "124",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "Mould_walls",
    Keyword: "Mould treatment, wall cleaning",
    avg_num_searches: "70, 110",
    header: "Mould Treatment, Wall Cleaning | CleanBee.ie",
    "Length (max 70 characters)": "44",
    description:
      "Mould Treatment, Wall Cleaning all across the Ireland ✴️ Professional cleaning services in Ireland ❗ ❱❱❱ Visit our page and book the cleaning!",
    "Length (max 155 characters)": "142",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "Airbnb_Office",
    Keyword: "airbnb cleaning, office cleaning",
    avg_num_searches: "30, 320",
    header: "Office Cleaning, Airbnb Cleaning | CleanBee.ie",
    "Length (max 70 characters)": "46",
    description:
      "Office cleaning, airbnb cleaning services ✴️ High quality deep cleaning procedures all across the Ireland ❗❱❱❱ Visit and book our services!",
    "Length (max 155 characters)": "139",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "Afterrenovationcleaning",
    Keyword: "after renovation cleaning",
    avg_num_searches: "50",
    header: "After renovation cleaning | CleanBee.ie\n",
    "Length (max 70 characters)": "40",
    description:
      "After renovation cleaning services in Ireland ✴️ Window cleaning, deep cleaning powerwashing afer renovation ❗❱❱❱ Visit our page and learn more!",
    "Length (max 155 characters)": "144",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "handyman-service",
    Keyword: "handyman near me",
    avg_num_searches: "1300",
    header: "Handyman Near Me - Ireland | CleanBee.ie",
    "Length (max 70 characters)": "40",
    description:
      "Handyman Near Me - all acreoss the Ireland ✴️ Hanging pictures, shelves, mirrors, fitting curtain poles, fitting blinds ❗❱❱❱ Visit!",
    "Length (max 155 characters)": "131",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "Painting",
    Keyword: "wall painting",
    avg_num_searches: "720",
    header: "Wall Painting | CleanBee.ie",
    "Length (max 70 characters)": "27",
    description:
      "Wall painting services all across the Ireland ✴️ Window frame painting, outdoors house painting, glass door painting and more ❗❱❱❱ Visit!",
    "Length (max 155 characters)": "137",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "Car_Cleaning",
    Keyword: "car cleaning",
    avg_num_searches: "480",
    header: "Car Cleaning | CleanBee.ie",
    "Length (max 70 characters)": "26",
    description:
      "Car Cleaning services all across the Ireland [good prices] ✴️ Jeep, regular car deep cleaning ❗❱❱❱ Visit and book our services!",
    "Length (max 155 characters)": "127",
    Communication: "Reikia, kad sukeltų."
  },
  {
    Page: "special-offers-and-sale",
    Keyword: "special offers",
    avg_num_searches: "0",
    header: "Special offers | CleanBee.ie",
    "Length (max 70 characters)": "28",
    description:
      "Special offers ✴️ Book here the cleaning of your oven, kitchen or entire house ❗❱❱❱ Visit and learn more!",
    "Length (max 155 characters)": "105"
  },
  {
    Page: "End-Of-Tenancy-Cleaning",
    Keyword: "End Of Tenancy Cleaning",
    avg_num_searches: "350",
    header: "End of tenancy cleaning | CleanBee.ie",
    "Length (max 70 characters)": "37",
    description:
      "End of tenancy cleaning ✴️ High quality cleaning procedures all across the Ireland ❗ ❱❱❱ Learn more!",
    "Length (max 155 characters)": "100"
  },
  {
    Page: "Chimney-Cleaning",
    Keyword: "Chimney Cleaning",
    avg_num_searches: "300",
    header: "Chimney cleaning | CleanBee.ie",
    "Length (max 70 characters)": "30",
    description:
      "Chimney cleaning ✴️ ✴️ High quality cleaning procedures all across the Ireland ❗ ❱❱❱ Learn more!",
    "Length (max 155 characters)": "96"
  },
  {
    Page: "gifts",
    Keyword: "Gifts",
    avg_num_searches: "0",
    header: "Gifts | CleanBee.ie",
    "Length (max 70 characters)": "19",
    description:
      "Gifts ✴️ We offer house, bathroom, upholstery, kitchen, oven and other types of cleaning services ❗❱❱❱  Contact us!",
    "Length (max 155 characters)": "115"
  },
  {
    Page: "cleaning-products",
    Keyword: "Cleaning Products",
    avg_num_searches: "300",
    header: "Cleaning products | CleanBee.ie",
    "Length (max 70 characters)": "31",
    description:
      "Cleaning products ✴️ Book here the cleaning of your oven, kitchen or entire house ❗❱❱❱ Visit and learn more!",
    "Length (max 155 characters)": "108"
  },
  {
    Page: "https://cleanbee.ie/new-before-after/",
    Keyword: "Before & After",
    avg_num_searches: "0",
    header: "Before & After - Cleaning Services | CleanBee.ie",
    "Length (max 70 characters)": "48",
    description:
      "Before & After - Cleaning Services ✴️ Book here the cleaning of your oven, kitchen or entire house  ❗❱❱❱ Visit and learn more about our services!",
    "Length (max 155 characters)": "145",
    Communication: "Sukelta."
  },
  {
    Page: "https://cleanbee.ie/commercial/",
    Keyword: "Commercial Cleaning Services",
    avg_num_searches: "170",
    header: "Commercial Cleaning Services | CleanBee.ie",
    "Length (max 70 characters)": "42",
    description:
      "Commercial Cleaning Services all across the Ireland ✴️ Schools, factories and offices, hotels and restaurants cleaning ❗❱❱❱ Visit and learn more!",
    "Length (max 155 characters)": "146",
    Communication: "Sukelta."
  },
  {
    Page: "https://cleanbee.ie/careers/",
    Keyword: "Careers",
    avg_num_searches: "0",
    header: "Careers | CleanBee.ie",
    "Length (max 70 characters)": "21",
    description:
      "Careers - CleanBee.ie ✴️ Join forces with one of Ireland’s elite cleaning companies ❗❱❱❱ Learn more!",
    "Length (max 155 characters)": "100",
    Communication: "Sukelta."
  },
  {
    Page: "https://cleanbee.ie/contact/",
    Keyword: "home cleaning companies near me",
    avg_num_searches: "250",
    header: "Home Cleaning Company Near Me - Contacts | CleanBee.ie",
    "Length (max 70 characters)": "54",
    description:
      "Home Cleaning Company Near Me - Contacts ✴️ For commercial contact: commercial@cleanbee.ie ❗❱❱❱  Contact us!",
    "Length (max 155 characters)": "108",
    Communication: "Sukelta."
  }
];
